/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography } from '@coursera/cds-core';
import { ErrorIcon } from '@coursera/cds-icons';

import { Card } from 'bundles/program-loggedin-shared/components/Card';

import _t from 'i18n!nls/degree-home';

const styles = {
  grid: css`
    justify-content: center;
    align-items: center;
    text-align: center;
  `,
  icon: () => css`
    margin-top: var(--cds-spacing-400);
  `,
  text: () => css`
    margin-bottom: var(--cds-spacing-400);
    font-weight: 600;
    font-size: 20px;
  `,
};

const ErrorCard = ({ hideBorder = false }) => {
  const content = (
    <Grid css={styles.grid}>
      <ErrorIcon style={{ marginTop: 'var(--cds-spacing-400)' }} size="large" color="error" />
      {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
      <Typography variant="h2semibold" component="p" style={{ marginBottom: 'var(--cds-spacing-400)' }}>
        {_t('Failed to fetch data')}
      </Typography>
    </Grid>
  );

  return hideBorder ? content : <Card>{content}</Card>;
};

export default ErrorCard;
